import React from "react";
// import PropTypes from 'prop-types';
import createReactClass from "create-react-class";

import CircleMessageGroup from "./circle_message_group";
import EventMessageGroup from "./event_message_group";
import MessageGroup from "./message_group";
import Loader from "../loader";

export default createReactClass({
  displayName: "Root",
  fetchUnreads() {
    const companyId = (typeof this.props.companyId === 'undefined') ? null : this.props.companyId;
    $.ajax({
      url: "/api/message/unread_messages",
      data: {
        company_id: companyId,
      },
      dataType: "json",
      cache: false,
      success: function(data) {
        this.setState({
          loading: false,
          data: data,
        });
      }.bind(this),
      error: function() {}.bind(this),
    });
  },
  getInitialState() {
    return {
      loading: true,
      data: {
        unreadCircles: [],
        unreadEvents: [],
        unreadMessageGroups: [],
      },
    };
  },
  componentDidMount() {
    this.fetchUnreads();
    // $(window).on('focus', function() {
    //     this.fetchUnreads();
    //  }.bind(this));
    setInterval(this.fetchUnreads, 13000);
  },
  render() {
    const lastCircle = this.state.data.unreadCircles[
      this.state.data.unreadCircles.length - 1
    ];
    const lastEvent = this.state.data.unreadEvents[
      this.state.data.unreadEvents.length - 1
    ];
    const lastGroup = this.state.data.unreadMessageGroups[
      this.state.data.unreadMessageGroups.length - 1
    ];
    const eventCount = this.state.data.unreadEvents.length;
    const groupCount = this.state.data.unreadMessageGroups.length;
    const currentUserId = this.state.data.currentUserId;
    const unreadCircles = this.state.data.unreadCircles.map((circle) => {
      return (
        <CircleMessageGroup
          circle={circle}
          currentCircleId={0}
          hasUnreadMessage={true}
          key={circle.id}
          isLast={eventCount + groupCount === 0 && lastCircle === circle}
          unreadMessageCount={
            this.state.data.unreadCircleMessageCount[circle.id]
          }
          lastMessage={this.state.data.lastCircleMessages[circle.id]}
        />
      );
    });

    const unreadEvents = this.state.data.unreadEvents.map((event) => {
      return (
        <EventMessageGroup
          event={event}
          currentEventId={0}
          hasUnreadMessage={true}
          key={event.id}
          isLast={groupCount === 0 && lastEvent === event}
          unreadMessageCount={this.state.data.unreadEventMessageCount[event.id]}
          lastMessage={this.state.data.lastEventMessages[event.id]}
        />
      );
    });

    const unreadDirectMessageGroups = this.state.data.unreadMessageGroups.map(
      (group) => {
        return (
          <MessageGroup
            messageGroup={group}
            currentUserId={currentUserId}
            messageGroupId={0}
            hasUnreadMessage={true}
            key={group.id}
            isLast={lastGroup === group}
            unreadMessageCount={
              this.state.data.unreadDirectMessageCount[group.id]
            }
            lastMessage={this.state.data.lastDirectMessages[group.id]}
          />
        );
      }
    );

    const unreads =
      this.state.data.unreadMessageGroups.length !== 0 ||
      this.state.data.unreadCircles.length !== 0 ||
      this.state.data.unreadEvents.length !== 0 ? (
        <div>
          <div className="container col-md-8 col-lg-6">
            <h6 className="h6--list-title text-fz-14px text-black-50 pt-2">
              未読のメッセージ
            </h6>
          </div>
          <div className="bg-white h-100">
            <div className="container col-md-8 col-lg-6 h-100">
              <Loader isActive={this.state.loading} />
              <ul className="list-unstyled mb-0">
                {unreadCircles}
                {unreadEvents}
                {unreadDirectMessageGroups}
              </ul>
            </div>
          </div>
        </div>
      ) : (
        ""
      );

    return <div>{unreads}</div>;
  },
});
